export const meta = {
  id: 'pigeonhole-sort',
  name: 'Pigeonhole Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n + N)',
    space: 'O(n + N)'
  },
  description: 'Pigeonhole Sort is a non-comparison sorting algorithm that distributes elements into ordered pigeonholes based on their key values.'
};
